import { es } from './es';
import { en } from './en';

export type Translation = typeof en;

export const translations = {
  es,
  en,
};

export type SupportedLanguage = keyof typeof translations;

export const defaultLanguage: SupportedLanguage = 'es';

export const languages = [
  { code: 'es', name: 'Español' },
  { code: 'en', name: 'English' },
] as const;